import { Injectable, OnDestroy } from "@angular/core";
import { ReplaySubject, Subject } from "rxjs";
import { IUser } from "src/app/admin/users/models/IUser";
import { AuthService } from "./auth.service";
import { UsersService } from "src/app/admin/users/users.service";

@Injectable({
  providedIn: "root",
})
export class CurrentUserService implements OnDestroy {
  private destroy = new Subject<any>();
  private currentUserDataSubject = new ReplaySubject<IUser>(1);
  currentUserData$ = this.currentUserDataSubject.asObservable();
  constructor(user: AuthService, userService: UsersService) {
    user.loggedIn$.subscribe((isLoggedIn) => {
      if (isLoggedIn) {
        const userId = user.getUserId();
        userService.getUserProfile(userId).subscribe((u) => {
          this.currentUserDataSubject.next(u);
        });
      } else {
        this.currentUserDataSubject.next(null);
      }
    });
  }
  ngOnDestroy() {
    this.destroy.next();
  }
}
